import { api, ReactQueryOptions } from '@api';
import { useInvalidate } from '@hooks/TRPC_Hooks/useInvalidate';
import { useShowToast } from '@hooks/useShowToast';
type optionsType = ReactQueryOptions['UserManager']['deleteAvatar'];
export const useDeleteAvatar = (options?: optionsType) => {
  const {
    showToast
  } = useShowToast();
  const {
    updateProfileData
  } = useInvalidate();
  return api.UserManager.deleteAvatar.useMutation({
    mutationKey: ['UserManager.deleteAvatar'],
    onSuccess: data => {
      if (data === false) {
        showToast({
          variant: 'error',
          text: 'error.default'
        });
        return;
      }
      showToast({
        variant: 'success'
      });
      updateProfileData();
    },
    onError: () => {
      showToast({
        variant: 'error',
        text: 'error.default'
      });
    },
    ...options
  });
};